var React = require('react');

function ToiletMaleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"32","cy":"10","r":"5","key":0}),React.createElement("path",{"d":"M26.81 19h10.38a2 2 0 0 1 1.99 1.801L41 39H23l1.82-18.199A2 2 0 0 1 26.81 19zM29 59h6a2 2 0 0 0 2-2V39H27v18a2 2 0 0 0 2 2z","key":1})]));
}

ToiletMaleInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ToiletMaleInline;

ToiletMaleInline.default = ToiletMaleInline;
